// extracted by mini-css-extract-plugin
export var buttons = "_9l-0";
export var buttonsActive = "_9l-h";
export var cancelConfirm = "_9l-1";
export var closeButton = "_9l-2";
export var column = "_9l-3";
export var container = "_9l-4";
export var detailHeader = "_9l-6";
export var detailTitle = "_9l-7";
export var detailsContent = "_9l-5";
export var header = "_9l-8";
export var headerWithClose = "_9l-9";
export var icon = "_9l-a";
export var infoIcon = "_9l-c";
export var informationContainer = "_9l-b";
export var sideDrawer = "_9l-d";
export var sideDrawerOpen = "_9l-e";
export var stickyFooter = "_9l-f";
export var typeOption = "_9l-g";